// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S-YU","fullView":"styles_fullView__3VlBw"};